import { Link } from 'react-router-dom';
import { trackEvent } from '../lib/analytics';

export default function Footer() {
  return (
    <footer>
      <div className="foot-in">
        <Link className="lockup" to="/">
          <span className="mk">
            <span className="b">[</span>
            <span className="e">=</span>
            <span className="b">]</span>
          </span>
          <span className="wm">rcrt</span>
        </Link>
        <div className="foot-meta">
          rcrt · The Business Intelligence Runtime
          <br />
          Delivered by <span className="ph">possibl.ai</span> · Vendor-agnostic AI strategy,
          build, automation &amp; managed services.
          <br />
          Auckland · Wellington
        </div>
        <div className="foot-links">
          <a
            href="https://possibl.ai/rcrt"
            onClick={() => trackEvent('outbound_click', { target: 'possibl_rcrt', location: 'footer' })}
          >
            possibl.ai/rcrt
          </a>
          <a
            href="https://github.com/possibl-ai"
            onClick={() => trackEvent('outbound_click', { target: 'github', location: 'footer' })}
          >
            github
          </a>
          <a
            href="https://calendar.app.google/QJ59uMjvpv5EokCo7"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackEvent('cta_click', { cta: 'book_session', location: 'footer' })}
          >
            contact
          </a>
        </div>
      </div>
    </footer>
  );
}
